import { atom } from 'jotai';
import type { PROPAGATION_METHOD } from '../../labelling/reducers/actions/constants';
export const annotationPropagationMethod = atom<(typeof PROPAGATION_METHOD)[keyof typeof PROPAGATION_METHOD]>();